<template>
<v-container>

  <div class="display-1 animatetext">Impressum</div>
  <div class="headline animatetext">Angaben gem&auml;&szlig; &sect; 5 TMG:</div>
  <!--<p>&#91;Vorname&#93; &#91;Nachname&#93;
    <br /> &#91;Stra&szlig;e&#93;<br /> &#91;PLZ&#93; &#91;Ort&#93;</p>-->
  <p style="border:1px solid black;padding:2px;">Ich mag Datenschutz.<br>Aus diesem Grund gebe ich hier keine pers&ouml;nlichen Daten an. Dieses Impressum ist hier Freiwillig eingef&uuml;gt. Es ist nicht notwendig, da ich keine Dienstleistungen, wie in &sect; 5 TMG genannt anbiete. Daher verzichte
    ich auf entsprechende Angaben.</p>
  <div class="headline animatetext">Kontakt:</div>
  <p>E-Mail: <span class="myemail">&#64;</span></p>
  <div class="headline animatetext">Haftung f&uuml;r Inhalte</div>
  <p>Als Diensteanbieter sind wir gem&auml;&szlig; &sect; 7 Abs.1 TMG f&uuml;r eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach &sect;&sect; 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, &uuml;bermittelte
    oder gespeicherte fremde Informationen zu &uuml;berwachen oder nach Umst&auml;nden zu forschen, die auf eine rechtswidrige T&auml;tigkeit hinweisen.
  </p>
  <p>Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unber&uuml;hrt. Eine diesbez&uuml;gliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung
    m&ouml;glich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.</p>
  <div class=" headline animatetext">Haftung f&uuml;r Links</div>
  <p>Unser Angebot enth&auml;lt Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb k&ouml;nnen wir f&uuml;r diese fremden Inhalte auch keine Gew&auml;hr &uuml;bernehmen. F&uuml;r die Inhalte der verlinkten Seiten ist
    stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf m&ouml;gliche Rechtsverst&ouml;&szlig;e &uuml;berpr&uuml;ft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung
    nicht erkennbar.</p>
  <p>Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.</p>
  <div class="headline animatetext">Urheberrecht</div>
  <p>Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielf&auml;ltigung, Bearbeitung, Verbreitung und jede Art der Verwertung au&szlig;erhalb der Grenzen des Urheberrechtes bed&uuml;rfen
    der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur f&uuml;r den privaten, nicht kommerziellen Gebrauch gestattet.</p>
  <p>Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden,
    bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.</p>
  <p class="quelle">Quelle: <a target="_blank" href="https://www.e-recht24.de">erecht24.de</a></p>


  <div class="headline animatetext">Quellenangaben</div>
  <p>Das Hintergrundbild wurde 2010-2012 von Otto Greenslade erstellt und unter der <a target='_blank' href='http://creativecommons.org/licenses/by-sa/3.0/'>CC-BY-SA 3.0</a> Lizenz als Hintergrund f&uuml;r Ubuntu 12.04 ver&ouml;ffentlicht.
    <br><span class="quelle">Quelle: <a target="_blank" href='https://launchpadlibrarian.net/98896271/new_wallpaper_final_full_size02a.jpg'>https://launchpadlibrarian.net/98896271/new_wallpaper_final_full_size02a.jpg</a></span></p>
  <p>Die verwendete Schriftart ist &quot;Ubuntu&quot; von Canonical&trade;. Sie ist unter der <a target="_blank" href="https://bazaar.launchpad.net/~ufl-contributors/ubuntu-font-licence/trunk/view/head:/ubuntu-font-licence-1.0.txt">Ubuntu Font Licence 1.0</a> verf&ouml;ffentlicht.
    <br><span class="quelle">Quelle: <a target="_blank" href="https://design.ubuntu.com/font/">https://design.ubuntu.com/font/</a></span>
  </p>
  <p>Verwendete Symbole &quot;Icons&quot; sind Bestandteile von Googles Material Icons. Lizensiert mit der <a target="_blank" href="https://www.apache.org/licenses/LICENSE-2.0">Apache License Version 2.0</a>.
    <br><span class="quelle">Quelle: <a target="_blank" href="https://material.io/icons/">https://material.io/icons/</a></span>
  </p>
  <p>Das Twitter Logo wird unter Berücksichtigung der &quot;Brand Guidelines&quot; genutzt.
    <br><span class="quelle">Quelle: <a target="_blank" href="https://about.twitter.com/en_us/company/brand-resources.html">https://about.twitter.com/en_us/company/brand-resources.html</a></span>
  </p>
  <p>Das GitLab Logo ist unter der <a href="http://creativecommons.org/licenses/by-nc-sa/4.0/">Creative Commons Attribution-NonCommercial-ShareAlike 4.0 International License</a> veröffentlicht.
    <br><span class="quelle">Quelle: <a target="_blank" href="https://about.gitlab.com/press/">https://about.gitlab.com/press/</a></span>
  </p>
  <p>Das Pebble Logo wird wie in <a href="https://developer.pebble.com/legal/pebble-trademark/">diesen Richtlinien</a> erklärt benutzt.
    <br><span class="quelle">Quelle: <a target="_blank" href="https://commons.wikimedia.org/wiki/File:Pebble_logo.svg">https://commons.wikimedia.org/wiki/File:Pebble_logo.svg</a></span>
  </p>
  <p>Google Play und das Google Play-Logo sind Marken von Google LLC.
    <br><span class="quelle">Quelle: <a target="_blank" href="https://play.google.com/intl/en_us/badges/">https://play.google.com/intl/en_us/badges/</a></span>
  </p>
  <p>Nutzung des Ubuntu&reg; Logos &quot;Circle of Friends&quot; (auf mobilen Endger&auml;ten): Ubuntu is a registered trademark of Canonical Ltd.
    <br><span class="quelle">Quelle: <a target="_blank" href="https://design.ubuntu.com/downloads/">https://design.ubuntu.com/downloads/</a></span>
  </p>




  <br v-for="n in 4">




  <div class="display-1 animatetext">Datenschutzerkl&auml;rung</div>
  <div class="headline animatetext">Datenschutz</div>
  <p>Die Betreiber dieser Seiten nehmen den Schutz Ihrer pers&ouml;nlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerkl&auml;rung.</p>
  <p>Die Nutzung unserer Website ist in der Regel ohne Angabe personenbezogener Daten m&ouml;glich. Soweit auf unseren Seiten personenbezogene Daten (beispielsweise Name, Anschrift oder E-Mail-Adressen) erhoben werden, erfolgt dies, soweit m&ouml;glich,
    stets auf freiwilliger Basis. Diese Daten werden ohne Ihre ausdr&uuml;ckliche Zustimmung nicht an Dritte weitergegeben.</p>
  <p>Wir weisen darauf hin, dass die Daten&uuml;bertragung im Internet (z.B. bei der Kommunikation per E-Mail) Sicherheitsl&uuml;cken aufweisen kann. Ein l&uuml;ckenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht m&ouml;glich.</p>
  <!--<div class="animatetext">Cookies</div>
  <p>Die Internetseiten verwenden teilweise so genannte Cookies. Cookies richten auf Ihrem Rechner keinen Schaden an und enthalten keine Viren. Cookies dienen dazu, unser Angebot nutzerfreundlicher, effektiver und sicherer zu machen. Cookies sind kleine Textdateien, die auf Ihrem Rechner abgelegt werden und die Ihr Browser speichert.</p>
  <p>Die meisten der von uns verwendeten Cookies sind so genannte „Session-Cookies“. Sie werden nach Ende Ihres Besuchs automatisch gel&ouml;scht. Andere Cookies bleiben auf Ihrem Endger&auml;t gespeichert, bis Sie diese l&ouml;schen. Diese Cookies erm&ouml;glichen es uns, Ihren Browser beim n&auml;chsten Besuch wiederzuerkennen.</p>
  <p>Sie k&ouml;nnen Ihren Browser so einstellen, dass Sie &uuml;ber das Setzen von Cookies informiert werden und Cookies nur im Einzelfall erlauben, die Annahme von Cookies f&uuml;r bestimmte F&auml;lle oder generell ausschlie&szlig;en sowie das automatische L&ouml;schen der Cookies beim Schlie&szlig;en des Browser aktivieren. Bei der Deaktivierung von Cookies kann die Funktionalit&auml;t dieser Website eingeschr&auml;nkt sein.</p>
  -->
  <div class="headline animatetext">SSL-Verschl&uuml;sselung</div>
  <p>Diese Seite nutzt aus Gr&uuml;nden der Sicherheit und zum Schutz der &Uuml;bertragung vertraulicher Inhalte, wie zum Beispiel der Anfragen, die Sie an uns als Seitenbetreiber senden, eine SSL-Verschl&uuml;sselung. Eine verschl&uuml;sselte Verbindung
    erkennen Sie daran, dass die Adresszeile des Browsers von &quot;http://&quot; auf &quot;https://&quot; wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.</p>
  <p>Wenn die SSL-Verschl&uuml;sselung aktiviert ist, k&ouml;nnen die Daten, die Sie an uns &uuml;bermitteln, nicht von Dritten mitgelesen werden.</p>
  <!--<div class="animatetext">Recht auf Auskunft, L&ouml;schung, Sperrung</div>
  <p>Sie haben jederzeit das Recht auf unentgeltliche Auskunft &uuml;ber Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empf&auml;nger und den Zweck der Datenverarbeitung sowie ein Recht auf Berichtigung, Sperrung oder L&ouml;schung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema personenbezogene Daten k&ouml;nnen Sie sich jederzeit unter der im Impressum angegebenen Adresse an uns wenden.</p>
  -->
  <div class="headline animatetext">Widerspruch Werbe-Mails</div>
  <p>Der Nutzung von im Rahmen der Impressumspflicht ver&ouml;ffentlichten Kontaktdaten zur &Uuml;bersendung von nicht ausdr&uuml;cklich angeforderter Werbung und Informationsmaterialien wird hiermit widersprochen. Die Betreiber der Seiten behalten sich
    ausdr&uuml;cklich rechtliche Schritte im Falle der unverlangten Zusendung von Werbeinformationen, etwa durch Spam-E-Mails, vor.</p>
  <p class="quelle">Quelle: <a target="_blank" href="https://www.e-recht24.de">e-recht24.de</a></p>

</v-container>
</template>

<script>
export default {
  name: "imprint-page",
  data() {
    return {
      animatetexts: Array(),
      timers: Array()
    }
  },
  methods: {
    preparestrings() {
      //var htmlels = document.getElementsByClassName('animatetext');
      var htmlels = document.querySelectorAll('.animatetext');
      // console.log(htmlels);
      for (var i = 0; i < htmlels.length; i++) {
        this.animatetexts.push(htmlels[i].innerText);
        htmlels[i].innerText = this.randomChars(htmlels[i].innerText.length /*,htmlels[i].tagName*/ );
      }
    },
    randomChars(nr /*,tag*/ ) {
      var str = "";
      var possible = "_"; //(tag.substr(0,1)=="H")?"_":"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_/?&^.,:()[]{}#!<>'";
      for (var i = 0; i < nr; i++) {
        str += possible.charAt(Math.floor(Math.random() * possible.length));
      }
      return str;
    },
    startNormal() {
      //var htmlels = document.getElementsByClassName('animatetext');
      var htmlels = document.querySelectorAll('.animatetext');
      for (var i = 0; i < this.animatetexts.length; i++) {
        //htmlels[i].innerHTML = this.animatetexts[i];
        var speed = Math.floor(Math.random()*300) + 100 //(htmlels[i].tagName.substr(0,1)=="H")?150:20;
        this.animateOne(i, speed);
      }
      //this.animatetexts = ''; //free memory
    },
    animateOne(i, speed) {
      var c = 0;
      //var x = document.getElementsByClassName('animatetext')[i].innerText.length;
      var x = document.querySelectorAll('.animatetext')[i].innerText.length;
      // var y = i<5?200:(i<7?250:600);
      var tims = this.timers.length;
      this.timers.push(setInterval(function() {
        //var thishtml = document.getElementsByClassName('animatetext')[i].innerText;
        var thishtml = document.querySelectorAll('.animatetext')[i];
        thishtml.innerText = this.replaceChar(thishtml.innerText, c, this.animatetexts[i][c]);
        c += 1;
        if (c == this.animatetexts[i].length) {
          clearInterval(this.timers[tims]);
        }
      }.bind(this), speed, i, c, tims));
    },
    replaceChar(str, index, replacement) {
      return str.substr(0, index) + replacement + str.substr(index + 1);
    }
  },
  mounted() {
    this.preparestrings();
    this.startNormal();
  },
  beforeDestroy() {
    for (var i = 0; i < this.timers.length; i++) {
      clearTimeout(this.timers[i]);
    }
  }
}
</script>
<style>
.biggermargin{
  margin:20px;
  margin-left:70px;
  margin-right:70px;
}


.quelle,
.quelle a {
  color: #777;
}
</style>



// WEBPACK FOOTER //
// src/content/imprint-page.vue